<template>
  <div>
    <el-row type="flex" style="padding-bottom:20px;">
      <el-col :span="12">
        <el-row type="flex" justify="start" align="middle">
          <div class="title-h3 mr-r15">메시지 설정</div>
          <el-select style="width:127px;" v-model="selectedData" @change="onModuleChange">
            <el-option v-for="item in selectModuleData" :key="item.managetypeId" :label="item.managetypeName" :value="item.managetypeId"></el-option>
          </el-select>
        </el-row>
      </el-col>
      <el-col :span="12" class="btn-group-right">
        <el-button type="primary" @click="onSaveMsgFormat">저장</el-button>
        <el-button @click="onClickReset">취소</el-button>
      </el-col>
    </el-row>
    <!-- 0429 a-left 추가 -->
    <el-row :gutter="20" class="a-left">
      <el-col :span="19">
        <el-row>
          <el-row type="flex" justify="space-between">
            <div class="title-bar title-h4">이벤트 메시지 포맷</div>
          </el-row>
          <el-table class="mr-b30" :data="tableData" highlight-current-row @current-change="onChangeRowForEvent">
            <el-table-column :formatter="msgFormatter" label="구분이름" width="200" prop="eventMessageFormatName"></el-table-column>
            <el-table-column label="메시지 포맷" >
              <template slot-scope="scope">
                <w-event-format-input-component :data="scope.row" @append-msg-format="appendMsgFormat"></w-event-format-input-component>
              </template>
            </el-table-column>
          </el-table>
          <el-row type="flex" justify="space-between">
            <div class="title-bar title-h4">단문 전송 메시지 포맷</div>
          </el-row>
          <el-table :data="tableData" highlight-current-row @current-change="onChangeRowForSms">
            <el-table-column :formatter="msgFormatter" label="구분이름" width="200" prop="eventMessageFormatName"></el-table-column>
            <el-table-column label="메시지 포맷">
              <template slot-scope="scope">
                <w-sms-format-input-component :data="scope.row" @append-msg-format="appendMsgFormat"></w-sms-format-input-component>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
      </el-col>
      <el-col :span="5">
        <el-row>
          <div class="title-bar title-h4">포맷 설정 구분자</div>
        </el-row>
        <el-table :data="eventMsgFormatBasicData" highlight-current-row @row-dblclick="onDblClickName">
          <el-table-column label="구분자" prop="basicinfoSubname"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import msgUtil from '@/utils/message';
import basicinfoSubAPI from '@/api/model/basicinfo-sub';
import OperationSettingsAPI from '@/api/settings/common/operation-settings';
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import eq from 'lodash/eq';
import forEach from 'lodash/forEach';
import cloneDeep from 'lodash/cloneDeep';
import differenceWith from 'lodash/differenceWith';
import isEqual from 'lodash/isEqual';
import WEventFormatInputComponent from './components/EventFormatInputComponent';
import WSmsFormatInputComponent from './components/SmsFormatInputComponent';

export default {
  name: 'WEventMessageFormat',
  components: {
    WEventFormatInputComponent,
    WSmsFormatInputComponent,
  },
  data() {
    return {
      tableData: [],
      eventMsgFormatBasicData: [],
      selectedData: 'SMS',
      eventMsgData: [],
      eventMessageFormatData: [],
      tableDataOrigin: [],
      currentRowInfo: {},
      nowTableTargetObject: '',
    };
  },
  computed: {
    selectModuleData() {
      return this.$store.getters.activeManagetypesToShowForRsc;
    },
  },
  watch: {
    /**
     * 관리 구분 바인딩 시 첫번째 관리 구분이 자동으로 선택되도록 한다.
     * @author Ju
     * @param  {[type]} to [description]
     */
    selectModuleData: {
      immediate: true,
      handler(to) {
        if (!isEmpty(to)) {
          this.selectedData = this.selectModuleData[0].managetypeId;
        }
      },
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    /**
     * 이벤트 / 단문 메시지 포맷을 조회하여 테이블에 바인딩한다.
     * @author Song
     */
    loadData() {
      basicinfoSubAPI.getList('EVENT_MSG_FORMAT').then((response) => {
        this.eventMsgFormatBasicData = cloneDeep(response.data.data);
        // 19.09.02 > '오브젝트 이름' / '상위 오브젝트 이름' => 문자열 replace 시 '상위 오브젝트 이름'의 경우도 '오브젝트 이름' 문자열에 해당되어 함께 변경되는 문제 발생
        // 상위 오브젝트 (orderbyIndex가 비교적 높은) 대상 부터 비교하도록 변경
        this.eventMsgFormatBasicDataOrigin = response.data.data.sort((pre, next) => next.orderbyIndex - pre.orderbyIndex);
        // 아래 코드를 에러없이 진행하기 위해서는 basicinfo의 데이터가 우선적으로 필요하기에 then 이하에 구현한다.
        OperationSettingsAPI.getMessageFormatList({ managetypeId: this.selectedData }).then((responses) => {
          if (responses.data.success) {
            this.tableData = responses.data.data;
            this.msgConvert('eventMessageFormat');
            this.msgConvert('smsMessageFormat');
            this.tableDataOrigin = cloneDeep(this.tableData);
          }
        });
      });
    },
    /**
     * basicinfo_sub에서 조회해온 내용을 바탕으로 eventMessageFormat 데이터를 가공한다.
     * '$'를 기준으로 메시지 포맷이 이루어진다.
     * @author Song
     */
    msgConvert(kind) {
      const targetFormat = kind === 'eventMessageFormat' ? 'eventMessageFormatString' : 'smsMessageFormatString';
      forEach(this.tableData, (item, key) => {
        let i = 0;
        let start = 0;
        let end = 0;
        let str;
        let rec;
        let replaceData = '';
        let value = item[kind];
        const count = this.occurrences(value, '$') / 2;
        const fn = () => {
          str = value.substring(i);
          start = str.indexOf('$', 0);
          end = str.indexOf('$', start + 1);
          str = value.substring(i + start, i + end + 1); // +1
          rec = this.eventMsgFormatBasicData.find((targetItem) => targetItem.basicinfoSubid === str);
          if (rec) {
            value = value.replace(str, rec.basicinfoSubname);
            i = 0;
          } else {
            i = end + 1; // $RESULT_VALUE$ 에 관한 분기 (소스 수정 필요)
          }
          return value;
        };

        for (let f = 0; f < count; f += 1) {
          replaceData = fn();
        }
        this.$set(this.tableData[key], targetFormat, replaceData);
      });
    },
    // 모듈 변경 이벤트
    onModuleChange(value) {
      this.selectedData = value;
      this.loadData();
    },
    // 취소버튼 클릭 이벤트
    onClickReset() {
      this.tableData = cloneDeep(this.tableDataOrigin);
    },
    // eventMessageFormatName Formatter
    msgFormatter(row, column, value) {
      let result;
      result = value.replace('Not Key', '관리자원키 합계');
      result = result.replace('Key', '관리자원키');
      result = result.replace('Number Result', '임계치');
      result = result.replace('Result', '결과값');
      result = result.replace('Interface', '인터페이스');

      return result;
    },
    // 포맷 설정 구분자 더블 클릭 이벤트
    onDblClickName(item) {
      if (!eq(this.nowTableTargetObject, '')) {
        this.currentRowInfo[this.nowTableTargetObject] += item.basicinfoSubname;
        this.appendMsgFormat(this.currentRowInfo);
      }
    },
    // row 클릭 이벤트
    onChangeRowForEvent(item) {
      this.currentRowInfo = item;
      this.nowTableTargetObject = 'eventMessageFormatString';
    },
    onChangeRowForSms(item) {
      this.currentRowInfo = item;
      this.nowTableTargetObject = 'smsMessageFormatString';
    },
    // 변경한 메시지 포맷 저장
    onSaveMsgFormat() {
      // 수정 대상들을 전달 - class로 판별도 가능(dirty check)
      const params = differenceWith(this.tableData, this.tableDataOrigin, isEqual);
      OperationSettingsAPI.updateMessageFormat(params).then((response) => {
        if (response.data.success) {
          this.loadData();
          this.$message(msgUtil.getCustomResultMsgData('저장하였습니다.', true));
        } else {
          this.$message(msgUtil.getCustomResultMsgData('저장하지 못하였습니다.', false));
        }
      });
    },
    /**
     * 포맷 설정 구분자 추가 이후 대상 row를 다시 convert한다.
     * replace로 문자열을 포맷 설정 구분자로 교체한다.
     * @author Song
     */
    appendMsgFormat(item) {
      if (!isNil(item)) {
        let result = cloneDeep(item[this.nowTableTargetObject]);
        forEach(this.eventMsgFormatBasicDataOrigin, (target) => {
          const count = this.occurrences(item[this.nowTableTargetObject], target.basicinfoSubname);
          if (count > 0) {
            for (let i = 0; i < count; i += 1) {
              // convert
              result = result.replace(target.basicinfoSubname, target.basicinfoSubid);
            }
          }
        });
        if (this.nowTableTargetObject === 'eventMessageFormatString') {
          item.eventMessageFormat = result;
        } else {
          item.smsMessageFormat = result;
        }
      }
    },
    occurrences(string, subString, allowOverlapping) {
      // string += '';
      // subString += '';
      if (subString.length <= 0) return string.length + 1;

      let n = 0;
      let pos = 0;

      const step = allowOverlapping ? 1 : subString.length;
      while (true) {
        pos = string.indexOf(subString, pos);
        if (pos >= 0) {
          n += 1;
          pos += step;
        } else break;
      }
      return n;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settings/operation/EventAlarmSettings/EventSettings/EventMessageFormat.vue